export default "__VITE_ASSET__uRsTJ9UP__"